/* globals dataLayer, YT */
import _ from 'underscore';

function youtubeEvents(status) {
  const videoStatus = status;
  const videoName = window.youtubePlayer.getVideoData().title;
  const videoUrl = window.youtubePlayer.getVideoUrl();

  dataLayer.push({ event: 'videoPlay', videoStatus, videoName, videoUrl });
}

function onPlayerPercent(state) {
  if (state.getPlayerState() === YT.PlayerState.PLAYING) {
    let t =
      state.getDuration() - state.getCurrentTime() <= 1.5
        ? 1
        : (
            Math.floor((state.getCurrentTime() / state.getDuration()) * 10) / 10
          ).toFixed(2);
    let status;

    if (parseFloat(t) < 0.25) {
      t = 0.0;
      status = 'Started';
    } else if (parseFloat(t) < 0.5) {
      t = 0.25;
      status = '25%';
    } else if (parseFloat(t) < 0.75) {
      t = 0.5;
      status = '50%';
    } else if (parseFloat(t) < 1) {
      t = 0.75;
      status = '75%';
    } else {
      status = 'Completed';
    }

    t = t.toFixed(2);

    if (!state.lastP || t > state.lastP) {
      state.lastP = t;
      youtubeEvents(status);
    }

    if (state.lastP !== 1) {
      setTimeout(onPlayerPercent, 1000, state);
    }
  }
}

function onPlayerStateChange(state) {
  if (state.data === YT.PlayerState.PLAYING) {
    setTimeout(onPlayerPercent, 1000, state.target);
  }
}

function onPlayerReady() {
  const videoPlay = document.getElementsByClassName('video__play');
  const videoPause = document.getElementsByClassName('video__pause');

  window.youtubePlayer.playVideo();

  _.each(videoPlay, (play) => {
    play.addEventListener('click', () => {
      window.youtubePlayer.playVideo();
    });
  });

  _.each(videoPause, (pause) => {
    pause.addEventListener('mousedown', () => {
      window.youtubePlayer.pauseVideo();
    });
  });

  document.addEventListener('keydown', (event) => {
    const key = event.which || event.keyCode;
    if (key === 27) {
      window.youtubePlayer.pauseVideo();
    }
  });
}

const youtube = {
  methods: {
    youtubeLoad(target, youtubeId) {
      if (target.indexOf('lightboxVideo') > -1 && !this.$root.videoLoaded) {
        const youtubeVideo = new Promise((resolve, reject) => {
          document
            .querySelector('#video')
            .setAttribute(
              'src',
              `//www.youtube.com/embed/${youtubeId}?enablejsapi=1`
            );
          if (document.querySelector('#video').hasAttributes('src')) {
            resolve('Video successfully uploaded');
          } else {
            reject('Video failed to upload');
          }
        });

        youtubeVideo
          .then(() => {
            const tag = document.createElement('script');
            const firstScriptTag = document.getElementsByTagName('script')[0];
            tag.id = 'youtube-api';
            tag.src = '//www.youtube.com/iframe_api';
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.youtubePlayer = window.youtubePlayer || {};
            window.onYouTubeIframeAPIReady = () => {
              window.youtubePlayer = new window.YT.Player('video', {
                events: {
                  onReady: onPlayerReady,
                  onStateChange: onPlayerStateChange
                }
              });
            };
          })
          .catch((results) => {
            // eslint-disable-next-line no-console
            console.error(results);
          });

        this.$root.videoLoaded = youtubeId;
      }

      if (this.$root.videoLoaded !== youtubeId) {
        window.youtubePlayer.loadVideoById(youtubeId, 0);
        this.$root.videoLoaded = youtubeId;
      }
    }
  }
};

export default youtube;
